import { useTranslation } from '@/lib/i18n/useTranslation.client'

export function AddressCompanyNationalId({
  companyNationalId,
  'data-testid': dataTestid,
}: { companyNationalId?: string } & UiComponentProps) {
  const { t } = useTranslation(['address'])

  if (!companyNationalId) {
    return null
  }

  return (
    <span className="mt-1" data-testid={`${dataTestid}/companyNationalId`}>
      {t('address:companyNationalId', { companyNationalId })}
    </span>
  )
}
